export const getPaneStyles = ({ isActive }) => ({
  display: isActive ? 'flex' : 'none',
  position: 'relative',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
  width: '100%',
  overflow: 'hidden',
});
